import { render } from "./SegmentSearch.vue?vue&type=template&id=c42bf4b0&scoped=true&ts=true"
import script from "./SegmentSearch.vue?vue&type=script&lang=ts"
export * from "./SegmentSearch.vue?vue&type=script&lang=ts"

import "./SegmentSearch.vue?vue&type=style&index=0&id=c42bf4b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c42bf4b0"]])

export default __exports__